export default __webpack_public_path__ + "static/media/Japan_Particle_0010_Yamato_Fireworkstart.88debb77.png";